import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { ResultMappingInfo } from '@empathybroker/tsclient-play/dist/models/search/result-mapping-info'
import type { Dictionary } from '@empathyco/x-utils'
import type { Filter, Pagination } from '../models'
import { FiltersUtils } from './filters.utils'

export class PlayClientUtils {
  public static buildSearchParameters({
    filters,
    instance,
    params,
    pagination,
  }: {
    filters: Dictionary<Filter>
    instance: Instance
    params: Dictionary
    pagination: Pagination
  }) {
    return {
      params: this.getParams(params, filters, instance),
      page: this.getPage(pagination),
      resultMappingInfo: this.getResultMappingInfo(instance),
    }
  }

  public static buildBrowseParameters(payload: {
    filters: Dictionary<Filter>
    instance: Instance
    params: Dictionary
    pagination: Pagination
  }) {
    return this.buildSearchParameters(payload)
  }

  private static getParams(params: Dictionary, filters: Dictionary<Filter>, instance: Instance) {
    return Object.assign(FiltersUtils.getClientFilters(filters, instance), params)
  }

  private static getPage(pagination: Pagination) {
    return {
      start: (pagination.page - 1) * pagination.itemsPerPage,
      rows: pagination.itemsPerPage,
    }
  }

  private static getResultMappingInfo(instance: Instance): ResultMappingInfo {
    const resultMappings = instance.catalog?.resultMappings
    if (resultMappings) {
      return {
        urlPrefix: resultMappings.urlPrefix,
        imageUrlPrefix: resultMappings.imageUrlPrefix,
      }
    }

    return {}
  }
}
